import { DEBUG_TOOLS_ENABLED } from "@/constants/common";

// Module-level ring buffer + pub/sub so the Debugger module can observe every
// frame useSocketIO sends/receives without SocketContainer having to thread
// extra props through the chat context.

export type TDebugDirection = "in" | "out" | "system";

export type TDebugLogEntry = {
  id: number;
  direction: TDebugDirection;
  label: string;
  payload: unknown;
  timestamp: number;
};

const MAX_ENTRIES = 200;

let entries: TDebugLogEntry[] = [];
let nextId = 0;
let rawSender: ((raw: string) => boolean) | null = null;
const listeners = new Set<(entries: TDebugLogEntry[]) => void>();

const notify = () => {
  listeners.forEach((listener) => listener(entries));
};

export const debugBus = {
  log: (direction: TDebugDirection, label: string, payload: unknown) => {
    if (!DEBUG_TOOLS_ENABLED) return;
    nextId += 1;
    entries = [...entries, { id: nextId, direction, label, payload, timestamp: Date.now() }].slice(-MAX_ENTRIES);
    notify();
  },

  clear: () => {
    entries = [];
    notify();
  },

  getEntries: () => entries,

  subscribe: (listener: (entries: TDebugLogEntry[]) => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  // useSocketIO registers the live socket's send fn on connect and clears it on
  // teardown, so the panel can push a hand-written frame through the real socket.
  registerSender: (fn: ((raw: string) => boolean) | null) => {
    if (!DEBUG_TOOLS_ENABLED) return;
    rawSender = fn;
  },

  sendRaw: (raw: string): boolean => (rawSender ? rawSender(raw) : false),
};
